module.exports = __webpack_public_path__ + "TooltipBlob___3dYbN.svg";